import React, { Fragment } from 'react'
import classNames from 'classnames'
import Img from 'gatsby-image'
import PropTypes from 'prop-types'

import Link from '../Link'

const Content = ({ children, image }) => (
  <Fragment>
    {image && (
      <Img
        alt={image.alt}
        fluid={image.fluid}
        title={image.title}
        className={classNames('heimr-cards__item-image', image.className)}
      />
    )}
    <div className='heimr-cards__item-content'>{children}</div>
  </Fragment>
)

const Card = ({ children, className, linkTo, onClick, image }) => {
  const classes = classNames('heimr-cards__item', className)

  return (
    <div className={classes} onClick={onClick}>
      {linkTo ? (
        <Link className='heimr-cards__item-link' to={linkTo}>
          <Content image={image}>{children}</Content>
        </Link>
      ) : (
        <Content image={image}>{children}</Content>
      )}
    </div>
  )
}

Card.propTypes = {
  children: PropTypes.any,
  linkTo: PropTypes.string,
  onClick: PropTypes.func,
  image: PropTypes.shape({
    alt: PropTypes.string,
    className: PropTypes.string,
    fluid: PropTypes.object.isRequired,
    title: PropTypes.string,
  }),
}

export default Card
